import type { HTMLAttributes, ReactNode } from 'react'
import styles from './Tag.module.css'

export type TagTone = 'muted' | 'brass' | 'win' | 'loss'

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: TagTone
  children: ReactNode
}

/* Small status label: Coming soon, Folded, mode badges. */
export function Tag({ tone = 'muted', className, children, ...rest }: TagProps) {
  const cls = [styles.tag, tone !== 'muted' && styles[tone], className].filter(Boolean).join(' ')
  return <span className={cls} {...rest}>{children}</span>
}
